import React from 'react';
import ReactDOM from 'react-dom';
import "public/css/core.scss";
import "semantic-ui-css/semantic.css";
import RenderRoutes from "pages/app";
import { BrowserRouter } from "react-router-dom";

ReactDOM.render(
    <BrowserRouter>
        <RenderRoutes />
    </BrowserRouter>
    , document.getElementById('root')
);
